import { useQuery } from "react-query";
import API from "../shared-utils/api";
export const getPubConfig = async (pub_id) => {
    const { data } = await API.get(`/api/v1/rbzo/pubs/${pub_id}/getConfig`);
    return data;
};
export const usePubConfig = (pub_id, enabled = true) => {
    return useQuery(["pubConfig", pub_id], () => getPubConfig(pub_id), {
        enabled: enabled && !!pub_id,
        cacheTime: 1000 * 60 * 10,
        staleTime: 1000 * 60 * 12,
    });
};
